import React, { useRef } from 'react';
var VeltNotificationsPanelContentPeople = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-people", { ref: ref }, children));
};
export default VeltNotificationsPanelContentPeople;
